import "./_page-4.scss";
import {Form} from "react-bootstrap";
import useVMStore from "../../../../store";
export default function Page4() {
    const name = "page4";

    const {data, setData} = useVMStore();

    const value = [
        {
            label: "3D",
            val: "3D",
            imgSrc: process.env.REACT_APP_ROOT_DIRECTORY + "assets/images/3D.webp",
        },
        {
            label: "2D",
            val: "2D",
            imgSrc: process.env.REACT_APP_ROOT_DIRECTORY + "assets/images/2D.jpeg",
        },
    ];

    return (
        <Form>
            <Form.Group className="page-4 d-flex justify-content-around flex-column flex-sm-row">
                {value.map((v) => (
                    <div
                        className="d-flex col-sm-6 col-12 flex-column align-items-center mb-3 mb-sm-0"
                        key={"page_3_op" + v.val}
                    >
                        <label htmlFor={"cad_" + v.val}>
                            <img src={v.imgSrc} alt={v.val} />
                        </label>
                        <Form.Check
                            type="radio"
                            id={"cad_" + v.val}
                            className="mt-3"
                            label={v.label}
                            value={v.val}
                            checked={data[name] === v.val}
                            onChange={(e) => {
                                setData(e.target.value, "page4");
                            }}
                        />
                    </div>
                ))}
            </Form.Group>
            <Form.Switch
                className="justify-content-start mt-3 mx-5"
                id="3DAnd2D"
                label="Benötigen Sie einen Kostenvoranschlag für beide Varianten, 2D- und 3D-Dienstleistungen?"
                checked={data.page4 === "3D and 2D"}
                onChange={(e) => setData(e.target.checked ? "3D and 2D" : "3D", "page4")}
            />
        </Form>
    );
}
